import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '../../../services/logistic.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-search-stock',
  templateUrl: './search-stock.component.html',
  styleUrls: ['./search-stock.component.css']
})
export class SearchStockComponent implements OnInit {
    public gridView = false;

    public productSearchTextButtons: FormButton[] = [
        { id: 'erase', icon: 'fa fa-eraser', type: 'danger', onClick: () => this.clear('productsearch_searchtext') },
        { id: 'calculator', icon: 'fa fa-calculator', type: 'primary', onClick: () => this.openCalculator('productsearch_searchtext') },
        { id: 'search', icon: 'fas fa-search', type: 'primary', onClick: () => this.onSearch() }
    ];

    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public itemsListStocks: Item[] = [];

    public grid?: GridOptions;

    constructor(private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1444))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        return this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.setting.businessco_no });
    }

    private async loadProducts() {
        if (!this.setting) return;

        if (this.gridView && this.grid) {
            this.loadGridWithSearchtext();
        } else {
            return this.itemsListStocks = await this.datatask.Post(462, {
                productsearch_searchtext: this.setting.productsearch_searchtext,
                functionname: 'stock',
                stockplace_id: this.setting.stockplace_id,
                search_only_active_products: this.setting.search_only_active_products
            });
        }
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_searchstock_grid')
                .setLoadDataFunction({
                    method: 2574,
                    parameters: {
                        productsearch_searchtext: this.setting!.productsearch_searchtext,
                        functionname: 'stock',
                        stockplace_id: this.setting!.stockplace_id,
                        search_only_active_products: this.setting!.search_only_active_products
                    }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public searchItems() {

    }

    private loadGridWithSearchtext() {
        if (!this.setting) return;
        if (typeof this.setting.productsearch_searchtext === 'string' && this.setting.productsearch_searchtext.length === 0) return;

        this.loadGrid();
    }

    private onSearch() {
        this.loadProducts();
        this.loadGrid();
    }

    private clear(id: string) {
        if (!this.setting) return;

        switch (id) {
            case 'productsearch_searchtext':
                this.setting.productsearch_searchtext = '';

                if (this.setting!.productsearch_searchtext === '') {
                    this.loadGridWithSearchtext();
                    this.itemsListStocks = [];
                }
                break;
            default:
                break;
        }
    }

    private async openCalculator(id: string) {
        if (!this.setting) return;

        switch (id) {
            case 'productsearch_searchtext':
                if (id === 'productsearch_searchtext') {
                    const value = await this.modal.showCalculator(this.setting.productsearch_searchtext);

                    this.setting.productsearch_searchtext = value;
                }
                break;
            default:
                break;
        };
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadStockPlaces();
                break;
            case 'stockplace_id':

                break;
            case 'productsearch_searchtext':
                if (this.setting.productsearch_searchtext === '') {
                    this.loadGridWithSearchtext();
                    this.itemsListStocks = [];
                }
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();

        Promise.all([
            this.loadStockPlaces()
        ]).then(() => {
            this.loadProducts();
            this.loadGridWithSearchtext();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    productsearch_searchtext: string;
    stockplace_id: string;
    stockplace_name: string;
    businessco_no: string;
    stockplace_from_user: string;
    argtype: string;
    argvalue: string;
    search_only_active_products: string;
    show_search_only_active_products: string;
    show_setting: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('searchStock', {
//        templateUrl: 'views/components/views/searchStock/searchStock.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$window', 'stateService', 'utilityService', 'modalService', 'searchStockService', 'logisticService', 'ttGridFactory', 'rememberService', function ($window, stateService, utilityService, modalService, searchStockService, logisticService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let onDestroy = [];

//            let variableNames = {
//                businessco_no: '',
//                stockplace_id: '',
//                productsearch_searchtext: '',
//                search_only_active_products: '',
//            };

//            vm.model = {
//                productSearchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('productsearch_searchtext') },
//                    { id: 'calculator', icon: 'fa fa-calculator', color: 'primary', type: 'primary', onClick: () => openCalculator('productsearch_searchtext') },
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => onSearch() }
//                ],
//                setting: {},
//                selectListCompanies: [],
//                selectListStockPlaces: [],
//                itemsListStocks: [],
//                gridView: false,
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_searchstock_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await searchStockService.getSetting())[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            };

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no });
//            }

//            async function loadProducts() {
//                if (utilityService.validateParmsValue(vm.model.setting.productsearch_searchtext, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

//                return vm.model.itemsListStocks = await searchStockService.search({
//                    productsearch_searchtext: vm.model.setting.productsearch_searchtext,
//                    functionname: 'stock',
//                    stockplace_id: vm.model.setting.stockplace_id,
//                    search_only_active_products: vm.model.setting.search_only_active_products
//                });

//                if (vm.model.gridView && vm.model.gridReady) {
//                    loadGridWithSearchtext();
//                }
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            // Load only if valid searchtext, as some customers has a lot of data, and the page is frozen for minutes while fetching from database
//            function loadGridWithSearchtext() {
//                if (typeof vm.model.setting.productsearch_searchtext === 'string' && vm.model.setting.productsearch_searchtext.length === 0) return;

//                loadGrid();
//            }

//            async function loadGrid() {
//                if (vm.model.gridView === false) return;
//                if (utilityService.validateParmsValue(vm.model.setting.productsearch_searchtext, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

//                vm.grid.dataTask.loadData = {
//                    method: 2574,
//                    parameters: {
//                        productsearch_searchtext: vm.model.setting.productsearch_searchtext,
//                        functionname: 'stock',
//                        stockplace_id: vm.model.setting.stockplace_id,
//                        search_only_active_products: vm.model.setting.search_only_active_products,
//                    }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                        case 'businessco_no':
//                        case 'stockplace_id':
//                        case 'productsearch_searchtext':
//                            variableNames[key] = 'stock' + '.' + key;
//                            break;
//                        default:
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                            break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no':
//                    case 'stockplace_id':
//                    case 'search_only_active_products':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    case 'productsearch_searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.productsearch_searchtext, true) !== true) return;

//                        variableValue = vm.model.setting.productsearch_searchtext;
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            function openCalculator(id) {
//                modalService.showCalculator(vm.model.setting[id]).then(function (value) {
//                    vm.model.setting[id] = value;

//                    if (vm.model.setting.productsearch_searchtext > '') {
//                        Promise.all([
//                            rememberFunc('productsearch_searchtext')
//                        ]).then(() => {
//                            loadProducts();
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                    }
//                });
//            }

//            // #endregion OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'productsearch_searchtext':
//                        vm.model.setting.productsearch_searchtext = '';

//                        if (vm.model.setting.productsearch_searchtext === '') {
//                            Promise.all([
//                                rememberFunc('productsearch_searchtext')
//                            ]).then(() => {
//                                loadGridWithSearchtext();
//                                vm.model.itemsListStocks = [];
//                                Promise.resolve();
//                            });
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region SEARCH FUNCTIONS

//            vm.searchStock = function () {
//                return onSearch();
//            }

//            function onSearch() {
//                Promise.all([
//                    rememberFunc('productsearch_searchtext')
//                ]).then(() => {
//                    loadProducts();
//                    loadGrid();
//                    Promise.resolve();
//                });
//            }

//            // #endregion SEARCH FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                        Promise.all([
//                            rememberFunc('businessco_no')
//                        ]).then(() => {
//                            loadStockPlaces();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'stockplace_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

//                        vm.model.setting.stockplace_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('stockplace_id')
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'productsearch_searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.productsearch_searchtext) !== true) return;

//                        vm.model.setting.productsearch_searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.productsearch_searchtext, true) !== true) return;

//                        if (vm.model.setting.productsearch_searchtext === '') {

//                            Promise.all([
//                                rememberFunc('productsearch_searchtext')
//                            ]).then(() => {
//                                loadGridWithSearchtext();
//                                vm.model.itemsListStocks = [];
//                                Promise.resolve();
//                            });
//                        }
//                        break;
//                    case 'search_only_active_products':
//                        vm.model.setting.search_only_active_products = value;

//                        rememberFunc('search_only_active_products');
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region LAYOUT FUNCTIONS

//            function onWindowResize() {
//                if (window.innerWidth > 926) {
//                    if (vm.model.gridView === false) {
//                        //console.log("swapping to desktop view");
//                        vm.model.gridView = true;

//                        if (vm.model.gridReady === false) loadGrid();
//                    }
//                } else {
//                    if (vm.model.gridView === true) {
//                        //console.log("swapping to mobile view");
//                        vm.model.gridView = false;
//                    }
//                }
//            }

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();

//                Promise.all([
//                    loadStockPlaces()
//                ]).then(() => {
//                    loadProducts();
//                    loadGridWithSearchtext();
//                    Promise.resolve();
//                });

//                $window.addEventListener('resize', onWindowResize);
//                onWindowResize();
//            }

//            // #endregion LAYOUT FUNCTIONS

//            // #region ANGULAR FUNCTIONS

//            vm.$onDestroy = function () {
//                $window.removeEventListener('resize', onWindowResize);

//                onDestroy.forEach((fn) => {
//                    if (typeof fn === 'function') fn();
//                });
//            }

//            // #endregion ANGULAR FUNCTIONS

//        }]
//    });
//})();
